// A « Group purchase » — the minimum quantity a ticket or badge must be bought by — words its
// rule once, here, for every screen the visitor sees. The server keeps its own refusal constants.

export type GroupPurchaseEntryType = {
  name: string;
  groupMinSize?: number | null;
};

/**
 * The single wording of a « Group purchase » minimum, or null when the selection satisfies it.
 * The message names its entry: a ticketing listing several of them must say which one is short.
 */
export const getGroupPurchaseMinimumMessage = (
  entryType: GroupPurchaseEntryType,
  quantity: number
): string | null => {
  const minSize = entryType.groupMinSize ?? null;

  if (minSize === null || quantity <= 0 || quantity >= minSize) return null;

  return `Le nombre de ${entryType.name} doit être d'au moins ${minSize}.`;
};

// Same rule, for the screens that only gate a button and never render the wording.
export const isGroupPurchaseMinimumUnmet = (
  entryType: GroupPurchaseEntryType,
  quantity: number
): boolean => getGroupPurchaseMinimumMessage(entryType, quantity) !== null;
